import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '../interceptor/auth.service';
import { Constants } from 'src/app/app.constants';
import { AppService } from 'src/app/app.service';
import { HttpResponse } from '@angular/common/http';
import { StorageService } from 'src/app/app.storage.service';
import { userInfo } from 'node:os';
declare var $: any;
declare var bodymovin: any;
declare var lottie: any;
@Component({
  selector: 'app-landing',
  templateUrl: './landing.component.html',
  styleUrls: ['./landing.component.css']
})
export class LandingComponent implements OnInit {

  constructor(private storageService: StorageService, private appService: AppService, private authService: AuthService, private router: Router, private activatedRoute: ActivatedRoute) { }

  fragment: any;
  params: any;
  isWebApp: boolean = null;

  ngOnInit() {
 
    // this.accessToken = this.activatedRoute.snapshot.queryParamMap.get('access_token');
    this.fragment = this.activatedRoute.snapshot.fragment;
    
    if (this.fragment) {
      this.params = new URLSearchParams(this.fragment);
      let accessToken = this.params.get("access_token");
      let page = this.params.get("page");
      let osType = this.params.get("os_type");
      let switchUserId = this.params.get("userId")
      let expires_in = this.params.get("expires_in");
      let logged_time =  Date.now()/1000 | 0;
      this.storageService.setDataInLocalStorage("expires_in",expires_in);
      this.storageService.setDataInLocalStorage("logged_time",logged_time);
      if(page){
        this.isWebApp = false;
      }else{
        this.isWebApp = true;
      }
      if(switchUserId){
        this.storageService.setDataInLocalStorage("switchUserId",switchUserId);
      }
     
      
      // page = "account-creation"
      this.appService.getStarted(accessToken,switchUserId).subscribe((res: HttpResponse<any>) => {
      
        console.log(res);
       
        // res.body.status = 401;
        if (res.body.status == 200) {
          if(osType){
            this.storageService.setDataInLocalStorage("inAppOsType", osType);
          }
          this.storageService.setDataInLocalStorage("getStartedAccessToken", accessToken);
          let userData = res.body.user;
          if(userData && userData.id){
            switchUserId = JSON.stringify(userData.id);
            this.storageService.setDataInLocalStorage("switchUserId",switchUserId);
          }
          /// account creation from mobile native app

          if(page == Constants.LANDING_PAGE.ACCOUNT_CREATION){
            this.appService.workmateAppLinkSubject.next(page);
             
            //let userData = res.body.user;
            if (userData) {
             
              this.storageService.setDataInLocalStorage("userData", userData);
              if (res.body.logo) {
                this.storageService.setDataInLocalStorage("logo", res.body.logo);
              }
            
            
            }
            this.storageService.setDataInLocalStorage(Constants.STORAGE_KEY.NEW_ACCOUNT,true);
            this.router.navigate(['account']);
            return;
          }




          if (res.body.landing == Constants.LANDING_PAGE.GET_STARTED) {
            this.storageService.setDataInLocalStorage("newUserInfo", {name: res.body.name, profile: res.body.profile});
            this.router.navigate(['get-started']);
            return;
          }

          if (res.body.landing == Constants.LANDING_PAGE.FIELD_USER) {
            if(page && (page == Constants.DEFAULT_PAGE.REIMBURSEMENT || page == Constants.DEFAULT_PAGE.ATTENDANCE ||
              page == Constants.DEFAULT_PAGE.FORM)){
             // let userData = res.body.user;
              if (userData) {
               
                this.storageService.setDataInLocalStorage("userData", userData);
                if (res.body.logo) {
                  this.storageService.setDataInLocalStorage("logo", res.body.logo);
                }
                this.navigateToDefaultPage(page);
                return;
              }
            }else{
             // let userData = res.body.user;
              if (userData) {
              
                this.storageService.setDataInLocalStorage("userData", userData);
              }
              this.storageService.setDataInLocalStorage("newUserInfo", {name: res.body.name, profile: res.body.profile});
              this.router.navigate(['home/field-user']);
             //this.router.navigate(['home']);
              return;
            }
          }
         
          if (userData) {
            this.storageService.setDataInLocalStorage("userData", userData);
           
            if (res.body.logo) {
              this.storageService.setDataInLocalStorage("logo", res.body.logo);
            }
            if (res.body.landing == Constants.LANDING_PAGE.WELCOME) {
              let steps = res.body.steps;
              this.storageService.setDataInLocalStorage("steps", steps);
              if(steps && steps.length>0){
                let lastStep = steps[steps.length-1];
                if( lastStep == 1){
                  this.router.navigate(['account']);
                }else if(lastStep == 2){
                  this.router.navigate(['account/add-users']);
                }else if(lastStep == 3){
                  this.router.navigate(['account/manage']);
                }else if(lastStep == 4){
                  this.router.navigate(['account/app-demo']);
                }else{
                  this.router.navigate(['account']);
                }
              }else{
                this.router.navigate(['account']);
              }
             
            } else {
              // this.router.navigate(['home']);
              this.navigateToDefaultPage(page);
            }

          }
        } else if (res.body.status == 401) {
          if(!page){
            this.navigateToPage();
          }else{  
            this.router.navigate(['unauth']);
          }
        }
        else if (res.body.status == 400) {
          this.appService.showInfoPopup("Oops...", res.body.error_description);
        }
      }, (err) => {
        this.navigateToPage();
      })


      // this.appService.userInfo(accessToken)
      //   .subscribe((res: HttpResponse<any>) => {
      //     console.log(res);
      //     if (res.body.status == 200) {
      //       if (res.body.landing == Constants.LANDING_PAGE.FIELD_USER) {
      //         this.router.navigate(['field-user']);
      //         return;
      //       }
      //       let userData = res.body.user;
      //       if (userData) {
      //         // this.authService.setAccessToken(userData.accessToken);

      //         // this.storageService.setDataInLocalStorage("accessToken", userData.accessToken);
      //         this.storageService.setDataInLocalStorage("userData", userData);
      //         if (res.body.logo) {
      //           this.storageService.setDataInLocalStorage("logo", res.body.logo);
      //         }
      //         if (res.body.landing == Constants.LANDING_PAGE.WELCOME) {
      //           this.router.navigate(['account']);
      //         } else {
      //           this.router.navigate(['home']);
      //         }

      //       }
      //     } else if (res.body.status == 400) {
      //       this.appService.showInfoPopup("Oops...", res.body.error_description);
      //     }

      //   }, (error) => {
      //     console.log(error);
      //   });

    } else {
      this.navigateToPage();
    }
  }

  navigateToPage() {
    if (this.authService.isLoggedIn()) {
      this.router.navigate(['home']);
    } else {
      localStorage.removeItem("iuData");
      localStorage.removeItem("logo");
      // this.router.navigate(['login']);
      window.location.href = Constants.LOGIN_URL;
    }
  }

  navigateToDefaultPage(page?){
    // this.storageService.setDataInLocalStorage("navigationPage", null);
    if(page){
      // this.storageService.setDataInLocalStorage("navigationPage", page);
      this.appService.workmateAppLinkSubject.next(page);
      
    }
    if(page == Constants.DEFAULT_PAGE.PEOPLE){
      this.router.navigate(['home/people']);
    }else if(page == Constants.DEFAULT_PAGE.CLIENT){
      this.router.navigate(['home/client']);
    }else if(page == Constants.DEFAULT_PAGE.DASHBOARD){
      this.router.navigate(['home/task']);
    }else if(page == Constants.DEFAULT_PAGE.REPORT){
      this.router.navigate(['home/report']);
    }else if(page == Constants.DEFAULT_PAGE.REIMBURSEMENT){
      this.router.navigate(['home/reimburse']);
    }else if(page == Constants.DEFAULT_PAGE.ADMIN){
      this.router.navigate(['home/manage']);
    }else if(page == Constants.DEFAULT_PAGE.ATTENDANCE){
      this.router.navigate(['home/attendance']);
    }else if(page == Constants.DEFAULT_PAGE.FORM){
      this.router.navigate(['home/form']);
    }else{
      this.router.navigate(['home']);
    }
  }

}
